import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useField, useFormikContext } from 'formik'
import { useCallback, useEffect, useMemo } from 'react'
import { ILeadFormModel } from '@user/components/Leads/AddLeadForm/typings'

export type BestContactMethodOptionsType = {
  label: string
  value: string
}

export const options = [
  { label: 'Phone', value: 'Phone' },
  { label: 'Email', value: 'Email' },
  { label: 'SMS', value: 'SMS' },
]

export function useData({ required, name }) {
  const {
    setFieldValue,
    isSubmitting,
    values: { preferredMethodOfContact },
  } = useFormikContext<ILeadFormModel | IAddOpportunityFormModel>()

  const [{}, { error, touched }] = useField<string>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  const getOptionLabel = useCallback(
    (option: BestContactMethodOptionsType) => option.label,
    [],
  )

  const getId = useCallback((option: BestContactMethodOptionsType) => {
    return String(option.value)
  }, [])

  useEffect(() => {
    if (!preferredMethodOfContact && required && options?.length == 1) {
      setFieldValue(name, options[0].value)
    }
  }, [preferredMethodOfContact, required, setFieldValue])

  const initialOption = useMemo(() => {
    if (preferredMethodOfContact) {
      const value = options.find((x) => x.value === preferredMethodOfContact)
      if (value) return value
    }
    return null
  }, [options, preferredMethodOfContact])

  return {
    getOptionLabel,
    getId,
    options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
